import * as requestFromServer from './transfersByAgentCrud';
import {transfersByAgentSlice} from './transfersByAgentSlice';
import {transferSlice} from './transferSlice';
import {showGlobalMessage} from '../../_common/actions/globalMessage/showGlobalMessage';
import {messages as M} from '../../../../_metronic/i18n/messages';
import {logUserAction} from '../../../../utils';
import {pages as P} from '../../_common/constants/pages';
import {actionTypes as T} from '../../_common/constants/actionTypes';
import {subjects as S} from '../../_common/constants/subjects';
import {logMessages as L} from '../../_common/constants/logMessages';

const {actions} = transfersByAgentSlice;
const {actions: transferActions} = transferSlice;

export const getTransfersByAgent = agentID => dispatch => {
  dispatch(actions.startCall());

  return requestFromServer
    .getTransfersByAgent(agentID)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(actions.fetchTransfers({
        entities: data
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't find transfers by agent ${agentID}`;
      dispatch(actions.catchError({error}));
    });
};

export const setReceiptLineHidden = (receiptLineIDs, hidden, agentID) => dispatch => {
  dispatch(actions.startCall());
  const receiptLinesString = receiptLineIDs && Array.isArray(receiptLineIDs)
    ? receiptLineIDs.filter(Boolean).join(', ') : '';

  return requestFromServer
    .setReceiptLineHidden(receiptLineIDs, hidden)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.RECEIPT,
        T.EDIT,
        hidden === true
          ? L.TRANSFERS_SET_RECEIPT_LINE_HIDDEN(receiptLinesString, agentID)
          : L.TRANSFERS_SET_RECEIPT_LINE_SHOWED(receiptLinesString, agentID),
        'edit',
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't change receipt lines status`;
      dispatch(actions.catchError({error}));
    });
};

export const setReceiptLineOwnership = (receiptLineIDs, agentID) => dispatch => {
  dispatch(actions.startCall());
  const receiptLinesString = receiptLineIDs && Array.isArray(receiptLineIDs)
    ? receiptLineIDs.filter(Boolean).join(', ') : '';

  return requestFromServer
    .setReceiptLineOwnership(receiptLineIDs, agentID)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.RECEIPT,
        T.EDIT,
        L.TRANSFERS_SET_RECEIPT_LINE_OWNERSHIP(receiptLinesString, agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't change receipt lines ownership`;
      dispatch(actions.catchError({error}));
    });
};

export const resetReceiptLineOwnership = (receiptLineIDs, agentID) => dispatch => {
  dispatch(actions.startCall());
  const receiptLinesString = receiptLineIDs && Array.isArray(receiptLineIDs)
    ? receiptLineIDs.filter(Boolean).join(', ') : '';

  return requestFromServer
    .resetReceiptLineOwnership(receiptLineIDs)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.RECEIPT,
        T.EDIT,
        L.TRANSFERS_RESET_RECEIPT_LINE_OWNERSHIP(receiptLinesString, agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't change receipt lines ownership`;
      dispatch(actions.catchError({error}));
    });
};

export const getTransfer = (transferID) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .getTransfer(transferID)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      dispatch(transferActions.fetchTransfer({
        entities: data?.transfer
      }));
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't get transfer data`;
      dispatch(transferActions.catchError({error}));
    });
};

export const createTransfer = (data) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .createTransfer(data)
    .then(response => {
      const {errorCode} = response.data;
      const paycheck = [
        data?.formValues?.paycheck?.date?.month,
        data?.formValues?.paycheck?.date?.year
      ].filter(Boolean).join(' - ');
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.TRANSFER,
        T.CREATE,
        L.TRANSFERS_CREATE(paycheck, data?.agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't create transfer`;
      dispatch(transferActions.catchError({error}));
    });
};

export const editTransfer = (data) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .editTransfer(data)
    .then(response => {
      const {errorCode} = response.data;
      const paycheck = [
        data?.formValues?.paycheck?.date?.month,
        data?.formValues?.paycheck?.date?.year
      ].filter(Boolean).join(' - ');
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.TRANSFER,
        T.EDIT,
        L.TRANSFERS_EDIT(paycheck, data?.agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't edit transfer`;
      dispatch(transferActions.catchError({error}));
    });
};

export const deleteTransfer = (transferID, paycheck, agentID) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .deleteTransfer(transferID)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.TRANSFER,
        T.DELETE,
        L.TRANSFERS_DELETE(paycheck, agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't delete transfer`;
      dispatch(transferActions.catchError({error}));
    });
};

export const splitReceiptLines = (receiptLineId, amounts, agentID) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .splitReceiptLines(receiptLineId, amounts)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.RECEIPT,
        T.EDIT,
        L.TRANSFERS_SPLIT_RECEIPT_LINES(receiptLineId, agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't split receipt lines`;
      dispatch(transferActions.catchError({error}));
    });
};

export const unsplitReceiptLine = (receiptLineId, agentID) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .unsplitReceiptLine(receiptLineId)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.RECEIPT,
        T.EDIT,
        L.TRANSFERS_UNSPLIT_RECEIPT_LINES(receiptLineId, agentID),
        errorCode
      );

      if (errorCode !== 0) throw new Error();
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't unsplit receipt lines`;
      dispatch(transferActions.catchError({error}));
    });
};

export const updateTamal = (data) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .updateTamal(data)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.TRANSFER,
        T.EDIT,
        L.TRANSFERS_UPDATE_TAMAL(data?.agentID, data?.tamalID),
        errorCode
      );

      if (errorCode === 0) {
        dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      } else {
        dispatch(showGlobalMessage(M[errorCode]));
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't update tamal`;
      dispatch(transferActions.catchError({error}));
    });
};

export const updateAvgIncome = (data) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .updateAvgIncome(data)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.TRANSFER,
        T.EDIT,
        L.TRANSFERS_UPDATE_INCOME(data?.agentID, data?.avgIncome),
        errorCode
      );

      if (errorCode === 0) {
        dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      } else {
        dispatch(showGlobalMessage(M[errorCode]));
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't update income`;
      dispatch(transferActions.catchError({error}));
    });
};

export const updateAdminNotes = (agentID, adminNotes) => dispatch => {
  dispatch(transferActions.startCall());

  return requestFromServer
    .updateAdminNotes(agentID, adminNotes)
    .then(response => {
      const {errorCode} = response.data;
      logUserAction(
        P.TRANSFERS_BY_AGENT,
        S.TRANSFER,
        T.EDIT,
        L.TRANSFERS_UPDATE_ADMIN_NOTES(agentID, adminNotes),
        errorCode
      );

      if (errorCode === 0) {
        dispatch(showGlobalMessage(M.REQUEST_ENDED_SUCCESSFULLY));
      } else {
        dispatch(showGlobalMessage(M[errorCode]));
      }
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = `Can't update admin notes`;
      dispatch(transferActions.catchError({error}));
    });
};

export const findAgents = (text) => {

  return requestFromServer
    .findAgents(text)
    .then(response => {
      const {errorCode, data} = response.data;
      if (errorCode !== 0) throw new Error();

      return data?.list ? data.list : [];
    })
    .catch(error => {
      console.error({error});
      error.clientMessage = 'Can\'t find data';
    });
};
